import { Rental } from "types";

export const getRentalPaymentInfo = (rental: Rental) => rental.invoices.at(-1)?.payment_info;
